export const STEPS = [
  {
    name: "เลือกเเผน",
    value: 1
  },
  {
    name: "กรอกข้อมูล",
    value: 2
  },
  {
    name: "ชำระเงิน",
    value: 3
  }
];

export const INSURED_AMOUNT = [
  {
    label: "ต่ำกว่า 8,000,000 บาท",
    value: "ต่ำกว่า 8,000,000 บาท"
  },
  {
    label: "ตั้งแต่ 8,000,000 บาท ขึ้นไป",
    value: "ตั้งแต่ 8,000,000 บาท ขึ้นไป"
  }
];

export const CONTACT_TIME = [
  {
    label: "08.30 - 11.00",
    value: "08.30 - 11.00"
  },
  {
    label: "11.00 - 14.00",
    value: "11.00 - 14.00"
  },
  {
    label: "14.00 - 17.00",
    value: "14.00 - 17.00"
  }
];

export const CONTACT_REASON = [
  {
    label: "เรื่องสุขภาพ",
    value: "เรื่องสุขภาพ"
  },
  {
    label: "ผลิตภัณฑ์ / โปรโมชั่น",
    value: "ผลิตภัณฑ์ / โปรโมชั่น"
  },
  {
    label: "สนใจซื้อประกัน",
    value: "สนใจซื้อประกัน"
  },
  {
    label: "อื่นๆ",
    value: "อื่นๆ"
  }
]
export const DISEASE = [
  {
    label: "โรคลมชัก",
    value: "โรคลมชัก"
  },
  {
    label: "โรคหัวใจ",
    value: "โรคหัวใจ"
  },
  {
    label: "โรคความดันโลหิตศูง",
    value: "โรคความดันโลหิตศูง"
  },
  {
    label: "โรคเบาหวาน",
    value: "โรคเบาหวาน"
  },
  {
    label: "โรคกระดูกและ / หรือกล้ามเนื้อ",
    value: "โรคกระดูกและ / หรือกล้ามเนื้อ"
  },
  {
    label: "โรคมะเร็ง",
    value: "โรคมะเร็ง"
  },
  {
    label: "โรคเอดส์",
    value: "โรคเอดส์"
  }
];

export const DISABILITY = [
  {
    label: "อวัยวะพิการ",
    value: "อวัยวะพิการ"
  },
  {
    label: "ความสามารถในการมองเห็น",
    value: "ความสามารถในการมองเห็น"
  },
  {
    label: "ความสามารถในการได้ยิน",
    value: "ความสามารถในการได้ยิน"
  },
  {
    label: "ความผิดปกติของร่างกายที่ได้รับผลกระทบจากอุบัติเหตุ",
    value: "ความผิดปกติของร่างกายที่ได้รับผลกระทบจากอุบัติเหตุ"
  }
];
